import store from '../../store';

export const initializeApp = async (lang) => {
  try {
    await store.dispatch('AuthFirebase/initializeFirebase');

    await Promise.all([
      store.dispatch('Init/fetch')
    ]);

  } catch (error) {
    console.error('Error in initializeApp:', error);
  }
};
